<template>
    <div class="my-strategy">
        <div class="own-strategy">
            <p class="own-title">我创建的策略</p>
            <div class="own-tabs">
                <ul>
                    <li class="item" @click="itemTab = 1" :class="{'active': itemTab === 1}">策略回测</li>
                    <li class="item" @click="itemTab = 2" :class="{'active': itemTab === 2}">回测一下</li>
                </ul>
            </div>
            <div class="own-list" v-if="userId">
                <strategy-backtest v-show="itemTab === 1"></strategy-backtest>
                <backtest-once v-show="itemTab === 2"></backtest-once>
            </div>
        </div>
        <div class="own-collect-strategy">
            <p class="own-collect-title">我收藏的策略</p>
            <div class="own-collect-list-body">
                <div class="body-search">
                    <label>
                        <input type="text" v-model="keyWord" placeholder="搜索关键词" @keyup.enter="updateSearch">
                        <span @click="updateSearch"></span>
                    </label>
                </div>
                <div class="body-list">
                    <div class="list">
                        <p v-show="isSearchResult && !isFromSearch">
                            <span>你还没有收藏任何策略哦~</span><br>
                            <router-link :to="'/strategysquare'">
                                    <span class="created">去策略广场逛逛</span>
                            </router-link>
                        </p>
                        <p v-show="isSearchResult && isFromSearch">暂无查询列表数据</p>
                        <vue-loading v-show="isshowloading" style="height: calc(100% - 20px);border:none;top:0;left:0"></vue-loading>
                        <div class="list-item" v-for="(item, index) in ownCollectDataLiat" :key="index" v-show="!isSearchResult && !isshowloading">
                            <div class="item-left">
                                <div class="item-logo">
                                    <router-link :to="'/strategysquare/' + item.property.id" :key="item.property.id" @click="strategyDetailPoint(item.property.id)">
                                        <img :src="'/svg/' + item.property.id + '.svg'">
                                    </router-link>
                                </div>
                            </div>
                            <div class="item-right">
                                <div class="item-right-t">
                                    <div class="item-details">
                                        <router-link :to="'/strategysquare/' + item.property.id" :key="item.property.id" @click="strategyDetailPoint(item.property.id)">
                                            <h3>{{item.property.name}}</h3>
                                        </router-link>
                                        <div class="item-label">
                                            <span v-for="(itemm, i) in item.property.tags" :key="i" v-show="itemm === '' ? false : true">{{itemm}}</span>
                                        </div>
                                        <p><b>投资逻辑：</b>{{item.property.logic}}</p>
                                    </div>
                                    <div class="item-annual-income">
                                        <p :class="item.property.annualYield | riseAndFallClass">{{item.property.annualYield | safePercentFixedTwo}}</p>
                                        <span>年化收益</span>
                                    </div>
                                    <div class="item-success-rate">
                                        <p :class="item.property.winRate | riseAndFallClass">{{item.property.winRate | safePercentFixedTwo}}</p>
                                        <span>成功率</span>
                                    </div>
                                    <div class="item-user">
                                        <div class="item-user-img right">
                                            <img :src="item.author.avatar">
                                        </div>
                                        <p class="right">{{item.author.userName}}</p>
                                    </div>
                                </div>
                                <div class="item-right-b">
                                    <div class="item-comment">
                                        <span>评论({{item.interaction.commentNum}})</span>
                                    </div>
                                    <div class="item-collect" @click="removeCollect(item.property.id)">
                                        <div class="item-collect">
                                            <span>收藏数({{item.interaction.collectNum}})</span>
                                        </div>
                                    </div>
                                    <div class="item-set-date">
                                        <span>创建时间：{{item.property.ctime}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pagination-heart">
                        <vue-pagination
                            class="square-page"
                            :page-size="pageSize"
                            :total="total"
                            @current-change="goPage">
                        </vue-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="own-discuss">
            <p class="own-discuss-title">我参与的讨论</p>
            <div class="own-discuss-tabs">
                <ul>
                    <li class="item" @click="discussTab = 1; receivePoint()" :class="{'active': discussTab === 1}">收到的评论</li>
                    <li class="item" @click="discussTab = 2; sendPoint()" :class="{'active': discussTab === 2}">发出的评论</li>
                </ul>
            </div>
            <div class="own-discuss-list" v-if="userId">
                <receive-discuss v-show="discussTab === 1"></receive-discuss>
                <send-discuss v-show="discussTab === 2"></send-discuss>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import strategyBacktest from './strategy-backtest'
    import backtestOnce from './backtest-once'
    import receiveDiscuss from './receive-discuss'
    import sendDiscuss from './send-discuss'
    export default {
        name: 'mystrategy',
        components: {
            strategyBacktest,
            backtestOnce,
            receiveDiscuss,
            sendDiscuss
        },
        data () {
            return {
                itemTab: 1,
                discussTab: 1,
                keyWord: '',
                pageSize: 10,
                currentPage: 1,
                sortSelect: '',
                isSearchResult: false,
                isshowloading: false,
                isFromSearch: true
            }
        },
        created () {
            if (this.userId == null) {
                // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
                window.LoginInstance.show()
                return
            }
            this.updateList()
        },
        activated () {
            if (this.userId == null) {
                // ThsLogin.showLoginBox(window.location.origin + '/reload.html')
                window.LoginInstance.show()
                return
            }
            // window.addEventListener('scroll', this.__scrollBar__)
            window.TA.log({id: this.buriedPoint.pageAccess, _sid: '__ths_001'})
            // window.TA.log({id: this.totalPoint, _sid: '__ths_002'})
        },
        // deactivated () {
        //     window.removeEventListener('scroll', this.__scrollBar__)
        // },
        computed: {
            userId () {
                return this.$store.getters['userInfo/userId']
            },
            buriedPoint () {
                return this.$buriedPoint.myStrategy
            },
            totalPoint () {
                return this.$buriedPoint.totalPlatformAccess
            },
            collectBacktestData () {
                return this.$store.getters['myStrategy/collectBacktestData']
            },
            ownCollectDataLiat () {
                return this.collectBacktestData.list
            },
            total () {
                return this.collectBacktestData.num
            }
        },
        methods: {
            // __scrollBar__ () {
            //     var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            //     if (document.documentElement.scrollHeight === document.documentElement.clientHeight + scrollTop) {
            //         window.TA.log(this.buriedPoint.scrollBar)
            //     }
            // },
            strategyDetailPoint (targid) {
                window.TA.log({ id: this.buriedPoint.inStrategyDetails, targid })
            },
            receivePoint () {
                window.TA.log(this.buriedPoint.takeDiscuss.receiveDiscuss)
            },
            sendPoint () {
                window.TA.log(this.buriedPoint.takeDiscuss.sendDiscuss)
            },
            goPage (page) {
                this.currentPage = page
            },
            removeCollect (id) {
                let self = this
                window.TA.log(self.buriedPoint.collectStrategy.cancelCollect)
                this.$confirm({
                    // 'type': 'warning',
                    'title': '您要取消收藏该策略吗？',
                    // 'smallTitle': '取消后，我们不再推送给你该机器人的股票操作信息',
                    'okBtnTitle': '确定',
                    'cancelBtnCallback': function (done) {
                        window.TA.log(self.buriedPoint.collectStrategy.cancelCollectCancel)
                        done()
                    },
                    'okBtnCallback': function (done) {
                        window.TA.log(self.buriedPoint.collectStrategy.cancelCollectOk)
                        axios.post('/strategysquare/uncollect', {
                            strategyId: id
                        }).then((res) => {
                            if (!res.data.result) {
                                self.$tip({
                                    message: '策略取消收藏失败',
                                    duration: 2000,
                                    type: 'error'
                                })
                            } else {
                                done()
                                self.$tip({
                                    message: '策略取消收藏成功',
                                    duration: 2000,
                                    type: 'success'
                                })
                                self.updateList()
                            }
                        }).catch((error) => {
                            done()
                            self.$tip({
                                message: (error ? error.message : '网络异常'),
                                duration: 2000,
                                type: 'error'
                            })
                        })
                    }
                })
            },
            updateSearch () {
                window.TA.log(this.buriedPoint.collectStrategy.search)
                this.updateList()
            },
            updateList () {
                var self = this
                this.isshowloading = true
                this.$store.dispatch('myStrategy/requestCollectBacktest', {
                    page: this.currentPage,
                    pageNum: this.pageSize,
                    sortType: this.sortSelect,
                    keyword: this.keyWord
                }).then((result) => {
                    if (self.ownCollectDataLiat.length === 0) {
                        self.isFromSearch = Boolean(self.keyWord)
                        self.isSearchResult = true
                    } else {
                        self.isSearchResult = false
                    }
                    self.isshowloading = false
                }).catch((error) => {
                    // 临时处理，后续优化
                    if (error.message === '用户未登录') {
                        return
                    }
                    self.isshowloading = false
                    self.$tip({
                        message: error ? error.message : '网络异常',
                        duration: 2000,
                        type: 'error'
                    })
                })
            }
        },
        watch: {
            currentPage () {
                this.updateList()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/mystrategy/main.scss';
</style>



// WEBPACK FOOTER //
// src/components/mystrategy/index.vue